<login-container [titel]="isForced ? 'Opdater adgangskode' : 'Skift adgangskode'" [arbejder]="arbejder" [technicianLogin]="true">
  <form class="tekniker-skift-kodeord" [formGroup]="form" (ngSubmit)="gemAdgangskode()">
    <div class="tekniker-skift-kodeord__toolbar">
      <button
        type="button"
        mat-icon-button
        class="button-back"
        (click)="tilbage()"
        [attr.aria-label]="isForced ? 'Tilbage til login' : 'Tilbage'"
        [title]="isForced ? 'Tilbage til login' : 'Tilbage'"
      >
        <mat-icon svgIcon="arrow-left" aria-hidden="true"></mat-icon>
      </button>
    </div>

    @if (isForced) {
      <p class="tekniker-skift-kodeord__intro">
        Af sikkerhedshensyn skal du vælge en ny adgangskode, før du kan bruge ServicePro.
      </p>
    } @else {
      <p class="tekniker-skift-kodeord__intro">Vælg en ny adgangskode til ServicePro.</p>
    }

    <p class="tekniker-skift-kodeord__hint">Adgangskoden skal være mindst 14 tegn og opfylde mindst 3 af 4 karakterkrav.</p>

    <ul class="tekniker-skift-kodeord__requirements" aria-live="polite">
      @for (requirement of requirements; track requirement.id) {
        <li
          class="tekniker-skift-kodeord__requirement"
          [class.tekniker-skift-kodeord__requirement--met]="requirement.visualState === 'met'"
          [class.tekniker-skift-kodeord__requirement--unmet]="requirement.visualState === 'unmet'"
          >
          {{ requirement.label }}
        </li>
      }
    </ul>

    @if (fejlBesked) {
      <div class="tekniker-skift-kodeord__error" role="alert">{{ fejlBesked }}</div>
    }

    <div>
      <mat-form-field>
        <input
          matInput
          placeholder="Adgangskode"
          formControlName="nytKodeord"
          type="password"
          id="skift-nytKodeord"
          autocomplete="new-password"
          required
          (blur)="onPasswordBlur()"
          />
      </mat-form-field>
    </div>

    <div>
      <mat-form-field>
        <input
          matInput
          placeholder="Gentag adgangskode"
          formControlName="gentagNytKodeord"
          type="password"
          id="skift-gentagNytKodeord"
          autocomplete="new-password"
          required
          />
          @if (
            form.controls.gentagNytKodeord.value &&
            form.controls.nytKodeord.value !== form.controls.gentagNytKodeord.value
            ) {
            <div class="tekniker-skift-kodeord__error">De to adgangskoder stemmer ikke overens.</div>
          }
        </mat-form-field>
      </div>

      <div class="tekniker-skift-kodeord__actions">
        <button type="submit" mat-flat-button color="primary" [disabled]="!kanGemme">Skift adgangskode</button>
      </div>
    </form>
  </login-container>
